<template>
  <li :class="['breadcrumb-item', active ? 'active' : '']">
    <slot />
  </li>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
